import { UrlBaseServicios, URL_PAYPAL } from './../parametros';
import { UrlBase, URL_PLUGIN, URL_PLUGIN_FRONTEND, URL_PLUGIN_SEGUROS, URL_PLUGIN_FRONT_GENERAL, URL_COTIZACIONES} from '../parametros';



/*
    GENERAL
*/

export const urlGenerarOtraCotizacion = `${URL_PLUGIN}generar-otra-cotizacion`;
export const urlGetProductos = `${URL_PLUGIN}get-lista-microseguros-v2`;
export const urlFormaPagoDudas = `${URL_PLUGIN}get-forma-pago-producto`;
export const urlGetCotizacionById = (idCotizacion) =>
  `${URL_PLUGIN}get-data-cotizacion&idCotizacion=${idCotizacion}`;
export const urlGetProudctoById = `${URL_PLUGIN}get-microseguro-by-id`;
export const urlSetProductoCotizacion = `${URL_PLUGIN}set-producto-cotizacion`;
export const setTitularUrl = `${URL_PLUGIN_FRONTEND}set-titular`;
export const getUrlCrearCotizacion = () => `${URL_PLUGIN}crear-cotizacion-login `;
export const getUrlCrearOtraCotizacion = () => `${URL_PLUGIN}generar-otra-cotizacion`;

// export const getPtpPagos = `${UrlBase}frontend/web/index.php?r=placetopay/pagos-reference`;

export const getPtpPagos = (idCotizacion, empAplica) =>
  `${UrlBaseServicios}placetopay/pagos/${empAplica}/${idCotizacion}`; //pagos-referencia
export const getPtpPagosXCedula = (cedula, fecha1, fecha2, empresa) =>
  `${UrlBase}/frontend/web/index.php?r=placetopay/consultar-pagosx-cedula&cedula=${cedula}&fechaIn=${fecha1}&fechaFin=${fecha2}&empresa=${empresa}`;
export const getPtpListadoPagosPendientes = (idCotizacion, historial) =>
  `${URL_PLUGIN_FRONTEND}poliza/historial-pagos-pendientes&idCotizacion=${idCotizacion}&historial=${historial}`;

// `${getPtpPagos}&idReferencia=${ref}`

export const urlSetBeneficiarios = `${URL_PLUGIN}set-beneficiarios`;
export const urlTitularAsBeneficiario = (idCotizacion) =>
  `${URL_PLUGIN}titular-as-beneficiario&idCotizacion=${idCotizacion}`;
export const urlSetTitularAsBeneficiarion = (idCotizacion) =>
  `${URL_PLUGIN}titular-as-beneficiario&idCotizacion=${idCotizacion}`;
export const urlEditVigencia = `${URL_PLUGIN}edit-vigencia-cotizacion`;
/*
  POLIZAS
*/

export const urlVerificarPoliza = `${URL_PLUGIN}verificar-estado-poliza`;

export const urlIngresarPoliza = (idCotizacion) =>
  `${URL_PLUGIN}ingresar-poliza&idCotizacion=${idCotizacion}`;

export const urlIntegrarpago = (idCotizacion) =>
  `${URL_PLUGIN_FRONTEND}cotizacion/integrarpago&idCotizacion=${idCotizacion}`;

/*
  EVICERTIA
*/

export const urlFirmarDocumentosEV = `${URL_PLUGIN}firmar-documentos-evicertia`;

export const urlPortalAig=(metodo,params) => `https://middleware.portalaig.com/frontend/web/index.php?r=${metodo}${params}` 

/*
    PLACE TO PAY
*/

export const urlConsultaEstadoSuscripcionPtP = (idSuscripcion) =>
  `${UrlBaseServicios}placetopay/retorna/suscripcion/${idSuscripcion}`; // retorna-ptp-suscripcion

export const urlHacerPagoSuscripcionPtp = `${UrlBase}frontend/web/index.php?r=placetopay/pago-suscripcion-generico`;

export const urlConsultarPagoPtpPendienteSuscripcion = (idCotizacion, empCodigo) =>
  `${UrlBaseServicios}placetopay/sonda/${empCodigo}/${idCotizacion}`; // sonda

export const urlPreguntasFrecuentesPtp = (empAplica) =>  `${UrlBaseServicios}placetopay/faq/${empAplica}`;

export const urlPagosPendientes = `${URL_PLUGIN_FRONTEND}poliza/obtener-pagos-pendientes&idCotizacion=`
export const urlPagarPendientes = `${URL_PLUGIN_FRONTEND}poliza/pagar-pendientes&idCotizacion={cotizacion}&idSuscripcion=`


/*
  ENVIAR CORREO CLIENTE PARA REALIZAR EL PAGO
*/

export const urlEnviarCorreoClientePago = `${URL_PLUGIN}correo-pago`;

export const urlFormaPago = `${URL_PLUGIN_SEGUROS}cotizacion/forma-pago`;


/*
  FLUJO 6
  AIGMETROPOLITANA
*/

export const urlEnviarCotizacionAig = (idCotizacion) =>
  `${URL_PLUGIN}enviar-cotizacion-aig&idCotizacion=${idCotizacion}`;

export const urlEnviarCotizacionAigAutoKm = (idCotizacion) =>
  `${URL_PLUGIN}enviar-cotizacion-landing&idCotizacion=${idCotizacion}`;

/*
FLUJO 10 
MOVISTAR Y COVERME
*/

export const urlBeforeSavePoliza = (idCotizacion) =>
  `${URL_PLUGIN_FRONTEND}cotizacion/before-save-poliza&idCotizacion=${idCotizacion}`;

// FLUJO 

export const urlValidarmx365 = () => `${URL_PLUGIN_SEGUROS}validation/add-product`;
export const urlValidaIdEmail = (identificacion, email) => `${URL_PLUGIN_FRONTEND}validation/existe-identificacion&identificacion=${identificacion}&correo=${email}`;


export const urlUpdateCotizacionById = () => `${URL_PLUGIN_FRONTEND}actualizar-cotizacion`;
export const urllistaCumplimientoSunidos = () => {
  let url = URL_PLUGIN_FRONTEND.replace("plugin", "site");
  return `${url}consulta-lista-cumplimiento`;
}
export const urlDepreciacionSunidos = () => `${URL_PLUGIN_FRONTEND}cotizacion/depreciacion`;
export const urlCertificadoCotizacion = (idCotizacion) => `${URL_PLUGIN_FRONTEND}cotizacion/guardar-solicitud&idCotizacion=${idCotizacion}`;

//export const urlgetTheme = (idCotizacion) => `${URL_PLUGIN_FRONTEND}cotizacion/correo-inicial-sunidos&idCotizacion=${idCotizacion}&tipoCorreo=`;
export const urlgetTheme = () => `${URL_PLUGIN_FRONTEND}configuracion-canal-comercial`;
export const urlCorreoInicialNotificacion = (idCotizacion, tipocorreo) => `${URL_PLUGIN_FRONTEND}cotizacion/correo-inicial-sunidos&idCotizacion=${idCotizacion}&tipoCorreo=${tipocorreo}`;//bienvenida
export const urlcalcularVigenciaPoliza = (idCotizacion) => {
  // let url = URL_PLUGIN_FRONTEND.replace("plugin", "polizas");
  return `${URL_PLUGIN_FRONTEND}poliza/calcular-vigencia-poliza&idCotizacion=${idCotizacion}`;//bienvenida
}
export const urlValDispositivo = (codigoCore) => `${URL_PLUGIN_FRONTEND}cotizacion/valor-dispositivo&codigoCore=${codigoCore}`
export const urlRegistroCivil = () => {
  let url = URL_PLUGIN_FRONTEND.replace("plugin", "cotizaciones");
  return `${url}consultar-datos-cedula-plugin&empresa=HUMANA&plataforma=WEB`
}
export const urlRecuperarPass = () => `${URL_PLUGIN}metodo-recuperar-password`
export const urlCambiarPass = () => `${URL_PLUGIN}metodo-cambiar-password`
export const urlGetToken = () => `${URL_PLUGIN}get-token`
export const urlAutoxKm = () => `${URL_PLUGIN_FRONTEND}crear/auto-km-pichincha`
export const urlCupoSeguro = () => `${URL_PLUGIN_FRONTEND}crear/cupo-seguro`
export const urlGetGrupos = (empBroker, canalComercial) => `${URL_PLUGIN}get-grupo-producto&canalComercial=${canalComercial}&empBroker=${empBroker}`
export const urlGetInfoGrupos = () => `${URL_PLUGIN}get-datos-grupo`
// {
//   empBroker,
//   canalComercial: empAplica,
// },`

export const urlCnsultarDatosProductoMx365 = () => `${URL_PLUGIN_FRONTEND}consultar-datos-producto`
export const urlGetUserAgencias = () => `${URL_PLUGIN}obtener-usuarios-agencia`
export const urlCrearPago365 = () => {
  const url = `${URL_PLUGIN_FRONTEND}`.replace("plugin", "garantia365");
  return `${url}realizar-pedido`
}
export const enviarCorreoEvicertia = () => `${URL_PLUGIN_FRONTEND}enviar-correo-firma-evicertia`
export const firmarDocumentos = () => `${URL_PLUGIN}firmar-documentos-evicertia`
export const urlGetProductosCanal = () => `${URL_PLUGIN_FRONTEND}obtener-canales-por-agencias-usuario`
export const urlAgenciasUsuario = () => `${URL_PLUGIN_FRONTEND}obtener-agencias-usuario`
export const urlActualizarEstadoFirma = () => `${URL_PLUGIN_FRONTEND}actualizar-estado-firma`
export const urlActionNotificarInspeccion = () => `${URL_PLUGIN_FRONTEND}cotizacion/correo-inspeccion`
export const urlFormularioContacto = () => `${URL_PLUGIN_FRONTEND}enviar-formulario-contacto`
export const urlLogosLogin = () => `${URL_PLUGIN_FRONTEND}imagenes-empresa-canal`
export const url = () => `${URL_PLUGIN_FRONTEND}imagenes-empresa-canal`
export const urlAlmacenarPago = () => `${URL_PAYPAL}almacenar-pago`
export const urlCoberuras = (empresa) => `${URL_PLUGIN_FRONTEND}set-coberturas&empresa=${empresa}&plataforma=WEB`
export const urlAsistencias = (empresa) => `${URL_PLUGIN_FRONTEND}set-asistencias&empresa=${empresa}&plataforma=WEB`
export const urlStripePago = () => `${UrlBaseServicios}stripe/checkout/mx365/WEB`
export const urlTokenFinanciero = `${URL_PLUGIN_FRONT_GENERAL}servicios/generar-token-financiero&plataforma=WEB`
export const urlValidarFinanciero = `${URL_PLUGIN_FRONT_GENERAL}servicios/verificar-token-financiero&plataforma=WEB`
export const urlGetPrecotizacion = `${URL_PLUGIN_FRONTEND}get-data-precotizacion&plataforma=WEB`
export const urlNotificacionPagoEfectivo = (empresa, idCotizacion) => `${URL_PLUGIN_FRONTEND}notifica-pago-efectivo&empresa=${empresa}&plataforma=WEB&idCotizacion=${idCotizacion}`
export const urladdAtributoCotizacion = (idCotizacion) => `${URL_PLUGIN_FRONTEND}agregar-atributo-cotizacion&idCotizacion=${idCotizacion}`
export const urlQrPago = ({ idCotizacion, empresa, preview = false, boton }) => `${URL_PLUGIN_FRONTEND}generar-qr-pago&idCotizacion=${idCotizacion}&empresa=${empresa}&plataforma=WEB&formapago=${boton}&preview=${preview}`
export const urlEnviarEmailQrPago = ({ idCotizacion, empresa, boton }) => `${URL_PLUGIN_FRONTEND}envio-qr-pago&boton=${boton}&idCotizacion=${idCotizacion}&empresa=${empresa}&plataforma=WEB`
export const urlGetDatosFirma = (idCotizacion) => `${URL_PLUGIN_FRONTEND}estado-firma&cotizacion=${idCotizacion}`
export const urlSenEmail =  `${URL_PLUGIN}envio-cotizacion-correo`   
export const urlTipoLead = `${URL_COTIZACIONES}tipo-lead-cotizacion`
export const urlCybersourcepago = (idCotizacion, metodoPago, ) => `https://servicios-pruebas.nuvem.cloud/cybersource/pago/${idCotizacion}/${metodoPago}`

export const urlGetUrlPdfCotizacion = `${URL_PLUGIN_FRONTEND}cotizacion/actualiza-pdf-cotizacion&idCotizacion=`;

